// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--V70_U","container":"styles-module--container--2l51g","card":"styles-module--card--3hMbO","number":"styles-module--number--1fkTv"};